import React, { useEffect, useState } from "react";
import { Button, Col, Input, Label, Row } from "reactstrap";
import _ from "lodash";
import { api, dateHelpers } from "../utils";
import { DesktopContainer } from "../layouts";
import { toast } from "react-toastify";
import Select from "react-select";

export default function MoveIVLabelToNewSite(props) {
   const [label, setLabel] = useState(null);
   const [labelLoaded, setLabelLoaded] = useState(false);
   const [searchType, setSearchType] = useState("barcodeId");
   const [searchValue, setSearchValue] = useState("");
   const [selectedSite, setSelectedSite] = useState("");
   const [sites, setSites] = useState([]);

   useEffect(() => {
      document.title = `Relocate IV Label`
      getSites();
   }, []);

   function getDefaultMoveToSite(list) {
      let result = _.filter(list, function (x) { return x.value === label.currentSite })
      return result.length ? result[0] : "";
   }

   function getLabel() {
      let id = parseInt(searchValue);
      if (isNaN(id)) {
         toast.error("Please enter a number for Barcode or Case Id");
         return;
      }
      if (searchType === "barcodeId") {
         api
            .fetch(`Item/GetInventoryLabelByBarcodeId/${id}`)
            .then((response) => {
               if (response && response.data) {
                  setLabel(response.data);
                  setLabelLoaded(true);
               } else {
                  toast.error("Error fetching label.")
               }
            })
            .catch(api.catchHandler)
      } else {
         api
            .fetch(`Item/GetInventoryLabelByCaseId/${id}`)
            .then((response) => {
               if (response && response.data) {
                  setLabel(response.data);
                  setLabelLoaded(true);
               } else {
                  toast.error("Error fetching label.");
               }
            })
      }
   }

   function getSites() {
      api
         .fetch("Reference/GetSiteList")
         .then((response) => {
            if (response.data?.success) {
               if (response.data) {
                  setSites({
                     SiteList: _.map(response.data.sites, x => {
                        return { label: x.siteWithDescription, value: x.siteId }
                     })
                  });
               }
            } else {
               toast.error("Failed to get sites.");
            }
         })
         .catch(api.catchHandler);
   }

   function moveLabel() {
      if (!label.trackingId) {
         toast.error("Label has no tracking id.");
         return;
      }
      let payload = {
         TrackingId: label.trackingId,
         SiteId: selectedSite.value
      };
      api
         .post("Item/InventoryTransferCaseSiteChange", payload)
         .then((response) => {
            if (response && response.data.success) {
               toast.success("Label successfully moved.");
               getLabel();
            } else {
               toast.error("Error transfering Label.");
            }
         })
         .catch(api.catchHandler);
   }

   return (
      <DesktopContainer screenName="Relocate IV Label">
         <Row className="mt-3 d-flex justify-content-center align-items-center filter-header">
            <Col xs="6">
               <Row className="mt-3 d-flex justify-content-center align-items-center">
                  <Col style={{ color: "white", fontSize: "1.25rem" }}>
                     Note: this utility only assigns label to the site but DOES NOT transfer any quantities in GP.
                  </Col>
               </Row>
               <Row className="mt-3 d-flex justify-content-center align-items-center">
                  <Col>
                     <Row className="mt-3 primaryDarkText">
                        <h3 style={{ color: "white" }}>Selection Criteria</h3>
                     </Row>
                     <Row className="mt-3 d-flex">
                        <Col xs="2">
                           <h6 style={{ color: "white", fontSize: "1.25rem" }}>Search By:</h6>
                        </Col>
                        <Col xs="4">
                           <Label check className="mx-2" style={{ color: "white" }}>
                              <Input type="radio" name="barcode-id-radio" value="barcodeId" className="mx-1" checked={searchType === "barcodeId"} onChange={(e) => setSearchType(e.target.value)} />
                              Barcode Id
                           </Label>
                           <Label check className="mx-2" style={{ color: "white" }}>
                              <Input type="radio" name="case-id-radio" value="caseId" className="mx-1" checked={searchType === "caseId"} onChange={(e) => setSearchType(e.target.value)} />
                              Case Id
                           </Label>
                        </Col>
                     </Row>
                     <Row className="mt-3 d-flex">
                        <Col xs="2">
                           <h6 style={{ color: "white", fontSize: "1.25rem" }}>Search Value:</h6>
                        </Col>
                        <Col xs="8">
                           <Input
                              type="text"
                              value={searchValue}
                              onChange={(e) => setSearchValue(e.target.value)}
                           />
                        </Col>
                     </Row>
                     <Row className="mt-3">
                        <Col xs="2">
                        </Col>
                        <Col>
                           <Button
                              className="shredButton"
                              onClick={() => getLabel()}
                           >
                              Find Label
                           </Button>
                        </Col>
                     </Row>
                  </Col>
               </Row>
            </Col>
         </Row>
         <Row className="mt-4 d-flex justify-content-center align-items-center">
            {labelLoaded ? (
               <Col xs="6">
                  <Row className="mt-3 primaryDarkText">
                     <h3>Label Information</h3>
                  </Row>
                  <Row className="mt-3">
                     <Col xs="2">
                        <h6>Created On:</h6>
                     </Col>
                     <Col xs="8">
                        <Input
                           type="text"
                           value={dateHelpers.toMDYDateString(label.createdDate)}
                           disabled
                        />
                     </Col>
                  </Row>
                  <Row className="mt-3">
                     <Col xs="2">
                        <h6>Barcode:</h6>
                     </Col>
                     <Col xs="8">
                        <Input
                           type="text"
                           value={label.barcodeString}
                           disabled
                        />
                     </Col>
                  </Row>
                  <Row className="mt-3">
                     <Col xs="2">
                        <h6>Case Id:</h6>
                     </Col>
                     <Col xs="8">
                        <Input
                           type="text"
                           value={label.caseNumber}
                           disabled
                        />
                     </Col>
                  </Row>
                  <Row className="mt-3">
                     <Col xs="2">
                        <h6>Item:</h6>
                     </Col>
                     <Col xs="8">
                        <Input
                           type="text"
                           value={label.itemWithDesc}
                           disabled
                        />
                     </Col>
                  </Row>
                  <Row className="mt-3">
                     <Col xs="2">
                        <h6>Item Class:</h6>
                     </Col>
                     <Col xs="8">
                        <Input
                           type="text"
                           value={label.itemClass}
                           disabled
                        />
                     </Col>
                  </Row>
                  <Row className="mt-3">
                     <Col xs="2">
                        <h6>Net Weight:</h6>
                     </Col>
                     <Col xs="8">
                        <Input
                           type="text"
                           value={label.netWeight}
                           disabled
                        />
                     </Col>
                  </Row>
                  <Row className="mt-3">
                     <Col xs="2">
                        Current Location:
                     </Col>
                     <Col xs="8">
                        <Input
                           type="text"
                           value={label.currentSite ? label.currentSite : ""}
                           disabled
                        />
                     </Col>
                  </Row>
                  <Row className="mt-3">
                     <Col xs="2">
                        Move To Site:
                     </Col>
                     <Col xs="8">
                        <Select
                           classNamePrefix="serviceThreadSelect"
                           options={sites.SiteList}
                           value={selectedSite}
                           onChange={(e) => setSelectedSite(e)}
                           defaultValue={getDefaultMoveToSite(sites.SiteList)}
                        />
                     </Col>
                  </Row>
                  <Row className="mt-3">
                     <Col xs="2"></Col>
                     <Col xs="8">
                        <Button
                           className="shredButton"
                           onClick={() => moveLabel()}
                        >
                           Move Label
                        </Button>
                     </Col>
                  </Row>
               </Col>
            ) : null}
         </Row>
      </DesktopContainer>
   );
}